import { cn } from '@/utils';

import OlyStreak from '@/assets/icons/olystreak.svg?react';

export const Logo = ({ className }: { className?: string }) => {
  return <OlyStreak className={cn('w-[140px]', className)} />;
};
